import {ClarityInjector} from '@src/utility/logger/libs/clarity'
import {OtelInjector} from '@src/utility/logger/libs/otel'
import {PosthogInjector} from '@src/utility/logger/libs/posthog'

import {LoggerStrategy} from './strategy'

const isDeploy = ['stage', 'sandbox', 'production'].includes(import.meta.env.VITE_ENVIRONMENT ?? 'development')
const isOtelEnabled = ['stage', 'production'].includes(import.meta.env.VITE_ENVIRONMENT ?? 'development')

export const logger = new LoggerStrategy([
  {
    class: new PosthogInjector(),
    enabled: isDeploy
  },
  {
    class: new ClarityInjector(),
    enabled: isDeploy
  },
  {
    class: new OtelInjector(),
    enabled: isOtelEnabled
  }
])
